import { createContext } from 'react';

import { HistogramChartTooltipConfig } from '../types/histogram-props.js';

export const HistogramTooltipContext =
  createContext<HistogramChartTooltipConfig>({
    variant: 'single',
  });
